export default __webpack_public_path__ + "static/media/eggetarian.9ca87366.svg";